import {Fragment, useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUser, faKey, faEye, faEyeSlash, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import '../auth.css'
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
function SignUp(){
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);
    const loginWindowRef = useRef(null);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();
    const navigate = useNavigate();

    const onSubmit = (data) => {
        setErrorMessage("");
        setDisableBtn(true);
        const {PasswordConfirm, ...restData} = data;
        axios.post(`${apiUrl}/api/auth/signup`, restData, {
            withCredentials: true
        })
            .then((res) => {
                if(res.data?.Succeeded){
                    navigate(`/auth/confirm-email?Email=${res.data.Email}&Token=${res.data.TempToken}`, { replace: true });
                }
                else{
                    setErrorMessage(res.data.Message);
                }
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.Message);
            })
            .finally(() => {
                setDisableBtn(false)
            })
    }

    const handleExternalLogin = (provider) => {
        if (loginWindowRef.current && !loginWindowRef.current.closed) {
            loginWindowRef.current.close();
        }
        const width = 400;
        const height = 700;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        const newWindow = window.open(
            `${apiUrl}/api/auth/external-login?provider=${provider}`,
            '_blank',
            `width=${width},height=${height},top=${top},left=${left},resizable=no`
        );
        loginWindowRef.current = newWindow;
        if (newWindow) newWindow.focus();
    }

    useEffect(() => {
        const handleMessage = (event) => {
            if(event.data?.success){
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
                navigate("/ai-chatbot", { replace: true });
            }
            else if (event.data?.message === "2FA_REQUIRED") {
                // handle 2FA
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
            }
            else if (event.data?.message) {
                setErrorMessage(event.data?.message);
                if (loginWindowRef.current && !loginWindowRef.current.closed) {
                    loginWindowRef.current.close();
                }
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    return (
        <Fragment>
            <div className="text-center mb-7">
                <h3 className="text-body-highlight">Sign Up</h3>
                <p className="text-body-tertiary fs-8-1">Create your account today</p>
            </div>
            <button className="btn btn-bt-secondary w-100 mb-3"
                    onClick={() => handleExternalLogin("Google")}
            >
                <svg className="svg-inline--fa fa-google fs-9 me-2 text-danger" aria-hidden="true" focusable="false"
                     data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 488 512" data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path>
                </svg>
                Sign up with google
            </button>
            <button className="btn btn-bt-secondary w-100"
                    onClick={() => handleExternalLogin("Facebook")}
            >
                <svg className="svg-inline--fa fa-facebook fs-9 me-2 text-primary" aria-hidden="true" focusable="false"
                     data-prefix="fab" data-icon="facebook" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512" data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"></path>
                </svg>
                Sign up with facebook
            </button>
            <div className="position-relative">
                <hr className="bg-body-secondary mt-5 mb-4"/>
                <div className="divider-content-center">or use email</div>
            </div>
            {
                errorMessage &&
                (
                    <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                        <span className="text-danger fw-bold fs-9 px-2">{errorMessage}</span>
                    </div>
                )
            }
            <form onSubmit={handleSubmit(onSubmit)} id="formSignUp">
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="UserName">username</label>
                    <div className="form-icon-container">
                        <input className="form-control form-icon-input" id="UserName" type="text" placeholder="UserName"
                               {...register("UserName", { required: "Username is required." })}/>
                        <FontAwesomeIcon icon={faUser} className="form-icon fs-9 text-body"/>
                    </div>
                    {errors.UserName && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.UserName.message}</p>
                    )}
                </div>
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="email">Email address</label>
                    <div className="form-icon-container">
                        <input className="form-control form-icon-input" id="Email" type="text" placeholder="name@example.com"
                               {...register("Email", {
                                   required: "Email is required.",
                                   pattern: {
                                       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                       message: "Invalid email address"
                                   }
                               })}/>
                        <FontAwesomeIcon icon={faEnvelope} className="form-icon fs-9 text-body"/>
                    </div>
                    {errors.Email && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.Email.message}</p>
                    )}
                </div>
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="password">Password</label>
                    <div className="form-icon-container" data-password="data-password">
                        <input className="form-control form-icon-input pe-6"
                               id="password"
                               type={!showPassword ? "password" : "text"}
                               placeholder="Password"
                               {...register("Password", {
                                   required: "Password is required.",
                                   pattern: {
                                       value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
                                       message: "Password must have at least 6 characters, 1 lowercase, 1 uppercase, 1 number and 1 special character."
                                   }
                               })}
                               data-password-input="data-password-input"/>
                        <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                        <FontAwesomeIcon onClick={() => setShowPassword(prev => !prev)} icon={!showPassword ? faEye : faEyeSlash} className="fs-10 px-3 h-100 position-absolute top-0 end-0 cursor-pointer" style={{paddingBottom: "2px"}}/>
                    </div>
                    {errors.Password && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.Password.message}</p>
                    )}
                </div>
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
                    <div className="form-icon-container" data-password="data-password">
                        <input className="form-control form-icon-input pe-6"
                               id="confirmPassword"
                               type={!showConfirmPassword ? "password" : "text"}
                               placeholder="Confirm Password"
                               data-password-input="data-password-input"
                               {...register("PasswordConfirm", {
                                   required: "Confirm Password is required.",
                                   validate: value =>
                                       value === watch("Password") || "Passwords do not match"
                               })}/>
                        <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                        <FontAwesomeIcon onClick={() => setShowConfirmPassword(prev => !prev)} icon={!showConfirmPassword ? faEye : faEyeSlash} className="fs-10 px-3 h-100 position-absolute top-0 end-0 cursor-pointer" style={{paddingBottom: "2px"}}/>
                    </div>
                    {errors.PasswordConfirm && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.PasswordConfirm.message}</p>
                    )}
                </div>
            </form>
            <div className="form-check mb-3">
                <input className="form-check-input" id="termsService" type="checkbox"/>
                <label className="form-label fs-9 text-transform-none" htmlFor="termsService">I accept the
                    <Link to="/home"> terms </Link>and <Link to="/home">privacy policy</Link>
                </label>
            </div>
            <button type="submit" form="formSignUp" disabled={disableBtn} className="btn btn-primary w-100 mb-3">
                {
                    disableBtn && (
                        <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                    )
                }
                Sign up
            </button>
            <div className="text-center">
                <Link className="fs-9 fw-bold" to="/auth/signin">Sign in to an existing account</Link>
            </div>
        </Fragment>
    )
}

export default SignUp;